import React from "react";
import Waypoint from "react-waypoint";
import classnames from "classnames";

export default class Inview extends React.Component {
	static defaultProps = {
		inViewClass: "inview"
	};
	constructor(props) {
		super(props);
		this.state = {};
	}
	setClassName(className) {
		this.setState({
			className
		});
	}

	inView = () => {
		this.setClassName(this.props.inViewClass);
		if (this.props.onInView) {
			this.props.onInView();
		}
	};

	outOfView = () => {
		this.setClassName("");
		if (this.props.onOutOfView) {
			this.props.onOutOfView();
		}
	};

	render() {
		let classes = classnames(this.props.className, this.state.className);
		return (
			<Waypoint onEnter={this.inView} onLeave={this.outOfView}>
				<div className={classes}>{this.props.children}</div>
			</Waypoint>
		);
	}
}
